import React from 'react';
import { Route, Router, Switch, useLocation } from 'react-router';

import useUserAccount from 'hooks/useUserAccount';
import LoginToken from 'screens/components/LoginToken';

import history from '../utils/history';
import AdminRouter from './adminRouter';
import PublicRouter from './publicRouter';
import TravelerRouter from './travelerRouter';

type UserTypeRouterProps = {
  isLoggedIn: boolean;
  isAdmin: boolean;
  isGroupApprover: boolean;
  isTravelArranger: boolean;
};

const NO_LOGIN_ROUTES = ['/registration', '/invite'];

const UserTypeRouter = ({ isLoggedIn, isAdmin, isGroupApprover, isTravelArranger }: UserTypeRouterProps) => {
  const location = useLocation();
  if (
    (location.search.includes('token=') || location.search.includes('code=')) &&
    !NO_LOGIN_ROUTES.some((route) => location.pathname.startsWith(route))
  )
    return <Route component={LoginToken} />;
  if (!isLoggedIn) return <PublicRouter />;
  if (isAdmin) return <AdminRouter />;
  return <TravelerRouter isTravelArranger={isTravelArranger} isGroupApprover={isGroupApprover} />;
};

const AppRouter = () => {
  const user = useUserAccount();

  return (
    <Router history={history}>
      <Switch>
        <UserTypeRouter
          isLoggedIn={!!user}
          isAdmin={user?.type === 'admin'}
          isGroupApprover={user?.isGroupApprover === true}
          isTravelArranger={user?.isTravelArranger ?? false}
        />
      </Switch>
    </Router>
  );
};

export default AppRouter;
